import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useSearchParams } from 'react-router-dom';
// Remover: import { createClient } from '@supabase/supabase-js';
import claqueteImg from '../assets/img/claquete.png';
import { useCriticas } from '../hooks/useCriticas';
import Tag from '../components/Tag';

const CriticasPageContainer = styled.div`
  min-height: 100vh;
  background: #f5f5f5;
`;

const Header = styled.header`
  background: #ba3b3b;
  color: #f0eadd;
  padding: 40px 0;
  text-align: center;
`;

const HeaderTitle = styled.h1`
  font-family: 'League Spartan', Arial, Helvetica, sans-serif;
  font-size: 48px;
  font-weight: bold;
  margin: 0 0 20px 0;
`;

const HeaderSubtitle = styled.p`
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 18px;
  margin: 0;
  opacity: 0.9;
`;

const AuthorHeader = styled.header`
  background: #ba3b3b;
  color: #f0eadd;
  padding: 40px 0;
  text-align: center;
  position: relative;
`;

const AuthorHeaderContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

const AuthorInfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
`;

const AuthorTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
`;

const AuthorAvatar = styled.img`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #f0eadd;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
`;

const AuthorName = styled.h1`
  font-family: 'League Spartan', Arial, Helvetica, sans-serif;
  font-size: 42px;
  font-weight: bold;
  margin: 0;
  line-height: 1.2;
`;

const AuthorSubtitle = styled.p`
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 18px;
  margin: 0;
  opacity: 0.9;
`;

const AuthorShortAbout = styled.p`
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 16px;
  margin: 0;
  opacity: 0.9;
  line-height: 1.4;
  text-align: left;
  max-width: 400px;
`;

const BackToAllButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
`;

const BackToAllButton = styled.button`
  background: #fff;
  color: #ba3b3b;
  border: 2px solid #ba3b3b;
  padding: 12px 30px;
  border-radius: 25px;
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  &:hover {
    background: #ba3b3b;
    color: #f0eadd;
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(186, 59, 59, 0.3);
  }
`;



const Content = styled.main`
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px 20px;
`;

const LoadingContainer = styled.div`
  text-align: center;
  padding: 60px 20px;
`;

const LoadingText = styled.p`
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 24px;
  color: #333;
`;

const ErrorContainer = styled.div`
  text-align: center;
  padding: 60px 20px;
  background: #fff;
  border-radius: 8px;
  margin: 20px 0;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
`;

const ErrorText = styled.p`
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 18px;
  color: #d32f2f;
`;

const CriticasGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
  margin-top: 40px;
  align-items: stretch;
`;

const CriticaCard = styled.article`
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 100%;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 30px rgba(0,0,0,0.15);
  }
`;

const CriticaHeader = styled.div`
  background: #ba3b3b;
  color: #f0eadd;
  padding: 20px 25px 25px 25px;
  flex-shrink: 0;
`;

const CriticaTitle = styled.h2`
  font-family: 'League Spartan', Arial, Helvetica, sans-serif;
  font-size: 24px;
  font-weight: bold;
  margin: 0;
  line-height: 1.2;
  text-align: center;
  min-height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CriticaContent = styled.div`
  padding: 25px;
  line-height: 1.6;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const CriticaText = styled.div`
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 16px;
  color: #333;
  line-height: 1.7;
  max-height: 200px;
  overflow: hidden;
  position: relative;
  flex: 1;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 60px;
    background: linear-gradient(transparent, rgba(255, 255, 255, 0.8), #fff);
    pointer-events: none;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'League Spartan', Arial, Helvetica, sans-serif;
    color: #ba3b3b;
    margin: 20px 0 10px 0;
  }

  h1 { font-size: 24px; }
  h2 { font-size: 22px; }
  h3 { font-size: 20px; }
  h4 { font-size: 18px; }
  h5 { font-size: 16px; }
  h6 { font-size: 14px; }

  p {
    margin: 0 0 15px 0;
  }

  ul, ol {
    margin: 15px 0;
    padding-left: 20px;
  }

  li {
    margin: 5px 0;
  }

  strong, b {
    font-weight: bold;
    color: #ba3b3b;
  }

  em, i {
    font-style: italic;
  }

  blockquote {
    border-left: 4px solid #ba3b3b;
    padding-left: 20px;
    margin: 20px 0;
    font-style: italic;
    color: #666;
  }

  a {
    color: #ba3b3b;
    text-decoration: underline;
    
    &:hover {
      color: #8b2a2a;
    }
  }

  &.expanded {
    max-height: none;
    
    &::after {
      display: none;
    }
  }
`;

const ReadMoreButton = styled.button`
  background: transparent;
  color: #ba3b3b;
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 500;
  border: none;
  padding: 8px 0;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 10px;
  position: relative;
  z-index: 1;
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    color: #8b2a2a;
    text-decoration-thickness: 2px;
  }
`;

const DialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

const DialogContent = styled.div`
  background: #fff;
  border-radius: 12px;
  max-width: 800px;
  width: 100%;
  max-height: 80vh;
  position: relative;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
`;

const DialogHeader = styled.div`
  background: #ba3b3b;
  color: #f0eadd;
  padding: 25px;
  border-radius: 12px 12px 0 0;
  flex-shrink: 0;
  z-index: 10;
`;

const DialogTitle = styled.h2`
  font-family: 'League Spartan', Arial, Helvetica, sans-serif;
  font-size: 28px;
  font-weight: bold;
  margin: 0 0 10px 0;
  line-height: 1.2;
`;

const DialogBody = styled.div`
  padding: 30px;
  overflow-y: auto;
  flex: 1;
`;

const DialogText = styled.div`
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 16px;
  color: #333;
  line-height: 1.7;

  h1, h2, h3, h4, h5, h6 {
    font-family: 'League Spartan', Arial, Helvetica, sans-serif;
    color: #ba3b3b;
    margin: 20px 0 10px 0;
  }

  h1 { font-size: 24px; }
  h2 { font-size: 22px; }
  h3 { font-size: 20px; }
  h4 { font-size: 18px; }
  h5 { font-size: 16px; }
  h6 { font-size: 14px; }

  p {
    margin: 0 0 15px 0;
  }

  ul, ol {
    margin: 15px 0;
    padding-left: 20px;
  }

  li {
    margin: 5px 0;
  }

  strong, b {
    font-weight: bold;
    color: #ba3b3b;
  }

  em, i {
    font-style: italic;
  }

  blockquote {
    border-left: 4px solid #ba3b3b;
    padding-left: 20px;
    margin: 20px 0;
    font-style: italic;
    color: #666;
  }

  a {
    color: #ba3b3b;
    text-decoration: underline;
    
    &:hover {
      color: #8b2a2a;
    }
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: -20px;
  right: -20px;
  background: #222;
  color: #f0eadd;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    background: #444;
  }
`;

const DialogFooter = styled.div`
  background: #f8f8f8;
  border-top: 1px solid #e0e0e0;
  padding: 20px 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80px;
  box-sizing: border-box;
  border-radius: 0 0 12px 12px;
  flex-shrink: 0;
`;

const CriticaFooter = styled.div`
  background: #f8f8f8;
  border-top: 1px solid #e0e0e0;
  padding: 20px 25px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 15px;
  min-height: 100px;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const WriterDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 60px;
  gap: 2px;
`;

const WriterLabel = styled.span`
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 12px;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const CriticaDate = styled.div`
  min-width: 100px;
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  color: #666;
  text-align: right;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  gap: 2px;
`;

const DateMain = styled.span`
  font-size: 14px;
  font-weight: 500;
`;

const DateYear = styled.span`
  font-size: 12px;
  opacity: 0.7;
`;

const HeaderRatingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 15px;
  margin-bottom: 10px;
`;

const ClaquetesContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

const Claquete = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
`;

const ClaqueteHalf = styled.div`
  width: 20px;
  height: 20px;
  position: relative;
  overflow: hidden;
`;

const ClaqueteHalfImg = styled.img`
  width: 40px;
  height: 20px;
  object-fit: contain;
  position: absolute;
  left: -20px;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 60px 20px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
`;

const EmptyText = styled.p`
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 20px;
  color: #666;
  margin: 0;
`;


const ClickableWriterInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 100%;
  cursor: pointer;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 0.8;
  }
`;

const ClickableWriterAvatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #ba3b3b;
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

const ClickableWriterName = styled.span`
  font-family: 'League Spartan', Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: bold;
  color: #ba3b3b;
  line-height: 1.2;
  cursor: pointer;
  transition: color 0.3s ease;

  &:hover {
    color: #8b2a2a;
  }
`;

const TakeLabel = styled.span`
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 10px;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 2px;
`;

const TextDateContainer = styled.div`
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  flex-direction: row;
  gap: 30px;
  justify-content: center;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
    align-items: center;
  }
`;

const TextDateItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 5px;
`;

const TextDateLabel = styled.span`
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 12px;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const TextDateValue = styled.span`
  font-family: 'League Spartan', Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #ba3b3b;
`;

const CriticasPage = () => {
  const { data, error, loading } = useCriticas();
  const [selectedCritica, setSelectedCritica] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  // Ref para evitar loops ao sincronizar modal com URL
  const isUpdatingFromCode = useRef(false);

  // Estado para o filtro ativo
  const [filteredAuthor, setFilteredAuthor] = useState(null);

  // Função para aplicar filtro por autor
  const filterByAuthor = (author) => {
    if (!author) return;

    const authorInfo = {
      id: author.id,
      name: author.name,
      photo_url: author.photo_url,
      short_about: author.short_about
    };

    setFilteredAuthor(authorInfo);

    // Preservar parâmetro de crítica se existir
    const newParams = { autor: author.id };
    const criticaId = searchParams.get('critica');
    if (criticaId) {
      newParams.critica = criticaId;
    }
    setSearchParams(newParams);
  };

  // Função para limpar filtro
  const clearFilter = () => {
    setFilteredAuthor(null);

    // Preservar parâmetro de crítica se existir
    const criticaId = searchParams.get('critica');
    if (criticaId) {
      setSearchParams({ critica: criticaId });
    } else {
      setSearchParams({});
    }
  };

  // Efeito para sincronizar com URL params
  useEffect(() => {
    const autorId = searchParams.get('autor');

    if (autorId && data) {
      // Encontrar o autor nos dados
      const author = data.find(critica =>
        critica.writers && critica.writers.id === parseInt(autorId)
      );

      if (author && author.writers) {
        setFilteredAuthor({
          id: author.writers.id,
          name: author.writers.name,
          photo_url: author.writers.photo_url,
          short_about: author.writers.short_about
        });
      }
    } else {
      setFilteredAuthor(null);
    }
  }, [searchParams, data]);

  // Efeito para abrir/fechar crítica específica baseado na URL
  useEffect(() => {
    // Se a mudança foi iniciada pelo código (openDialog/closeDialog), ignorar
    if (isUpdatingFromCode.current) {
      isUpdatingFromCode.current = false;
      return;
    }

    const criticaId = searchParams.get('critica');

    if (criticaId && data) {
      // Abrir modal se há ID na URL e o modal está fechado ou mostrando outra crítica
      const critica = data.find(c => c.id === parseInt(criticaId));
      if (critica && (!isDialogOpen || selectedCritica?.id !== critica.id)) {
        setSelectedCritica(critica);
        setIsDialogOpen(true);
      }
    } else if (!criticaId && isDialogOpen) {
      // Fechar modal se não há ID na URL mas o modal está aberto
      setIsDialogOpen(false);
      setSelectedCritica(null);
    }
  }, [searchParams, data, isDialogOpen, selectedCritica]);

  // Filtrar dados baseado no autor selecionado
  const filteredData = data ?
    (filteredAuthor ?
      data.filter(critica =>
        critica.writers && critica.writers.id === filteredAuthor.id
      ) :
      data
    ) : [];

  // Função para renderizar HTML de forma segura
  const renderHTML = (htmlContent) => {
    if (!htmlContent) return '';

    // Sanitização básica - remove scripts e outros elementos perigosos
    const sanitizedHTML = htmlContent
      .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
      .replace(/<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi, '')
      .replace(/javascript:/gi, '')
      .replace(/on\w+\s*=/gi, '');

    return { __html: sanitizedHTML };
  };

  // Função para formatar data
  const formatDate = (dateString) => {
    if (!dateString) return { main: '', year: '' };
    const date = new Date(dateString);
    const main = date.toLocaleDateString('pt-BR', {
      month: 'long',
      day: 'numeric'
    });
    const year = date.getFullYear().toString();
    return { main, year };
  };

  // Função para abrir dialog
  const openDialog = (critica) => {
    // Marcar que estamos atualizando via código
    isUpdatingFromCode.current = true;

    setSelectedCritica(critica);
    setIsDialogOpen(true);

    // Adicionar ID da crítica na URL, preservando outros parâmetros
    const newParams = { critica: critica.id };
    const autorId = searchParams.get('autor');
    if (autorId) {
      newParams.autor = autorId;
    }
    setSearchParams(newParams);
  };

  // Função para fechar dialog
  const closeDialog = () => {
    // Marcar que estamos atualizando via código
    isUpdatingFromCode.current = true;

    // Fechar modal imediatamente
    setIsDialogOpen(false);
    setSelectedCritica(null);

    // Remover ID da crítica da URL
    const newParams = {};
    const autorId = searchParams.get('autor');
    if (autorId) {
      newParams.autor = autorId;
    }
    setSearchParams(newParams);
  };

  // Função para verificar se o texto precisa ser truncado
  const needsTruncation = (text) => {
    if (!text) return false;
    // Estimativa simples baseada no número de caracteres
    const textLength = text.replace(/<[^>]*>/g, '').length;
    return textLength > 300; // Aproximadamente 300 caracteres
  };

  // Função para converter nota de 1-10 para 1-5
  const convertRating = (rate) => {
    if (!rate || rate < 1 || rate > 10) return 0;
    return rate / 2;
  };

  // Função para renderizar claquetes
  const renderClaquetes = (rating) => {
    const convertedRating = convertRating(rating);
    if (convertedRating === 0) return null;

    const fullClaquetes = Math.floor(convertedRating);
    const hasHalf = convertedRating % 1 !== 0;
    const claquetes = [];

    // Adiciona claquetes completas
    for (let i = 0; i < fullClaquetes; i++) {
      claquetes.push(
        <Claquete key={`full-${i}`} src={claqueteImg} alt="Claquete" />
      );
    }

    // Adiciona meia claquete se necessário
    if (hasHalf) {
      claquetes.push(
        <ClaqueteHalf key="half">
          <ClaqueteHalfImg src={claqueteImg} alt="Meia claquete" />
        </ClaqueteHalf>
      );
    }

    return claquetes;
  };

  if (loading) {
    return (
      <CriticasPageContainer>
        <Header>
          <HeaderTitle>Nossas Críticas</HeaderTitle>
          <HeaderSubtitle>Análises e opiniões sobre o mundo do entretenimento</HeaderSubtitle>
        </Header>
        <LoadingContainer>
          <LoadingText>Carregando críticas...</LoadingText>
        </LoadingContainer>
      </CriticasPageContainer>
    );
  }

  if (error) {
    return (
      <CriticasPageContainer>
        <Header>
          <HeaderTitle>Nossas Críticas</HeaderTitle>
          <HeaderSubtitle>Análises e opiniões sobre o mundo do entretenimento</HeaderSubtitle>
        </Header>
        <ErrorContainer>
          <ErrorText>Erro ao carregar as críticas. Tente novamente mais tarde.</ErrorText>
        </ErrorContainer>
      </CriticasPageContainer>
    );
  }

  return (
    <CriticasPageContainer>
      {filteredAuthor ? (
        <AuthorHeader>
          <AuthorHeaderContent>
            <AuthorInfoContainer>
              {filteredAuthor.photo_url ? (
                <AuthorAvatar
                  src={filteredAuthor.photo_url}
                  alt={filteredAuthor.name}
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              ) : (
                <AuthorAvatar
                  src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3E%3Ccircle cx='40' cy='40' r='40' fill='%23f0eadd'/%3E%3Ctext x='50%25' y='50%25' font-family='Arial' font-size='32' fill='%23ba3b3b' text-anchor='middle' dy='.3em'%3E?%3C/text%3E%3C/svg%3E"
                  alt="Avatar padrão"
                />
              )}
              <AuthorTextContainer>
                <AuthorName>{filteredAuthor.name}</AuthorName>
                {filteredAuthor.short_about && (
                  <AuthorShortAbout>{filteredAuthor.short_about}</AuthorShortAbout>
                )}
              </AuthorTextContainer>
            </AuthorInfoContainer>
            <AuthorSubtitle>Críticas e análises</AuthorSubtitle>
          </AuthorHeaderContent>
        </AuthorHeader>
      ) : (
        <Header>
          <HeaderTitle>Nossas Críticas</HeaderTitle>
          <HeaderSubtitle>Análises e opiniões sobre o mundo do entretenimento</HeaderSubtitle>
        </Header>
      )}
      <Content>
        {filteredAuthor && (
          <BackToAllButtonContainer>
            <BackToAllButton onClick={clearFilter}>
              ← Ver todas as críticas
            </BackToAllButton>
          </BackToAllButtonContainer>
        )}
        {!data || data.length === 0 ? (
          <EmptyState>
            <EmptyText>Nenhuma crítica encontrada no momento.</EmptyText>
          </EmptyState>
        ) : filteredData.length === 0 ? (
          <EmptyState>
            <EmptyText>Nenhuma crítica encontrada para este autor.</EmptyText>
          </EmptyState>
        ) : (
          <CriticasGrid>
            {filteredData.map((critica, index) => (
              <CriticaCard key={critica.id || index}>
                <CriticaHeader>
                  <CriticaTitle>{critica.title || 'Crítica sem título'}</CriticaTitle>
                </CriticaHeader>
                <CriticaContent>
                  {critica.rate && (
                    <HeaderRatingContainer>
                      <ClaquetesContainer>
                        {renderClaquetes(critica.rate)}
                      </ClaquetesContainer>
                      <span style={{ fontSize: '14px', color: '#666', marginLeft: '8px' }}>
                        ({convertRating(critica.rate)}/5)
                      </span>
                    </HeaderRatingContainer>
                  )}
                  <CriticaText
                    dangerouslySetInnerHTML={renderHTML(critica.text)}
                  />
                  {needsTruncation(critica.text) && (
                    <ReadMoreButton onClick={() => openDialog(critica)}>
                      Ler mais
                    </ReadMoreButton>
                  )}
                </CriticaContent>
                <CriticaFooter>
                  <ClickableWriterInfo onClick={() => critica.writers && filterByAuthor(critica.writers)}>
                    {critica.writers && critica.writers.photo_url && (
                      <ClickableWriterAvatar
                        src={critica.writers.photo_url}
                        alt={critica.writers.name || 'Avatar do autor'}
                        onError={(e) => {
                          e.target.style.display = 'none';
                        }}
                      />
                    )}
                    <WriterDetails>
                      <WriterLabel>Por</WriterLabel>
                      <ClickableWriterName>
                        {critica.writers ? critica.writers.name : 'Autor desconhecido'}
                      </ClickableWriterName>
                      <TakeLabel>
                        {critica.writers && critica.writers.take ? 'Equipe Takes' : 'Representante Takes'}
                      </TakeLabel>
                      {critica.tags && critica.tags.name && (
                        <Tag>{critica.tags.name}</Tag>
                      )}
                    </WriterDetails>
                  </ClickableWriterInfo>
                  <CriticaDate>
                    {critica.created_at && (() => {
                      const dateInfo = formatDate(critica.created_at);
                      return (
                        <>
                          <ClickableWriterName>Publicado em</ClickableWriterName>
                          <DateMain>{dateInfo.main}</DateMain>
                          <DateYear>{dateInfo.year}</DateYear>
                        </>
                      );
                    })()}
                  </CriticaDate>
                </CriticaFooter>
              </CriticaCard>
            ))}
          </CriticasGrid>
        )}
      </Content>

      {/* Dialog para texto completo */}
      {isDialogOpen && selectedCritica && (
        <DialogOverlay onClick={closeDialog}>
          <DialogContent onClick={(e) => e.stopPropagation()}>
            <DialogHeader>
              <DialogTitle>{selectedCritica.title || 'Crítica sem título'}</DialogTitle>
              <CloseButton onClick={closeDialog}>×</CloseButton>
            </DialogHeader>
            <DialogBody>
              <DialogText
                dangerouslySetInnerHTML={renderHTML(selectedCritica.text)}
              />
              {selectedCritica.rate && (
                <HeaderRatingContainer style={{ marginBottom: '20px' }}>
                  <ClaquetesContainer>
                    {renderClaquetes(selectedCritica.rate)}
                  </ClaquetesContainer>
                  <span style={{ fontSize: '16px', color: '#666', marginLeft: '8px' }}>
                    ({convertRating(selectedCritica.rate)}/5)
                  </span>
                </HeaderRatingContainer>
              )}
              
              <TextDateContainer>
                {selectedCritica.seen_at && (
                  <TextDateItem>
                    <TextDateLabel>Filme visto em</TextDateLabel>
                    <TextDateValue>
                      {(() => {
                        const seenDateInfo = formatDate(selectedCritica.seen_at);
                        return `${seenDateInfo.main} ${seenDateInfo.year}`;
                      })()}
                    </TextDateValue>
                  </TextDateItem>
                )}
                {selectedCritica.created_at && (
                  <TextDateItem>
                    <TextDateLabel>Crítica publicado em</TextDateLabel>
                    <TextDateValue>
                      {(() => {
                        const dateInfo = formatDate(selectedCritica.created_at);
                        return `${dateInfo.main} ${dateInfo.year}`;
                      })()}
                    </TextDateValue>
                  </TextDateItem>
                )}
              </TextDateContainer>
            </DialogBody>
            <DialogFooter>
              <ClickableWriterInfo onClick={() => selectedCritica.writers && filterByAuthor(selectedCritica.writers)}>
                {selectedCritica.writers && selectedCritica.writers.photo_url && (
                  <ClickableWriterAvatar
                    src={selectedCritica.writers.photo_url}
                    alt={selectedCritica.writers.name || 'Avatar do autor'}
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                )}
                <WriterDetails>
                  <WriterLabel>Por</WriterLabel>
                  <ClickableWriterName>
                    {selectedCritica.writers ? selectedCritica.writers.name : 'Autor desconhecido'}
                  </ClickableWriterName>
                  <TakeLabel>
                    {selectedCritica.writers && selectedCritica.writers.take ? 'Equipe Takes' : 'Representante Takes'}
                  </TakeLabel>
                  {selectedCritica.tags && selectedCritica.tags.name && (
                    <Tag>{selectedCritica.tags.name}</Tag>
                  )}
                </WriterDetails>
              </ClickableWriterInfo>
            </DialogFooter>
          </DialogContent>
        </DialogOverlay>
      )}
    </CriticasPageContainer>
  );
};

export default CriticasPage;
